import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLString
} from 'graphql'

export const emailDomainsType = new GraphQLObjectType({
  name: 'EmailDomains',
  fields: () => ({
    organizationID: {
      description: 'The unique ID for an organization',
      type: new GraphQLNonNull(GraphQLID)
    },
    domains: {
      description: 'A comma-separated list of email domain names',
      type: GraphQLString
    }
  })
})
